export const en = {
  uploadEmptyFileInput: 'Or Browse Your Computer',
  dragAndDrop: 'Drag & Drop Files Here',
  uploadFiles: 'Upload Files',
};
